import { isEmpty, has } from 'lodash';
import { ACTIONS } from '../actions/metaDatabase.reservationTransactions.actions';
import { getDefaultMetaReducers } from './utils';

const initialState = {};

const REDUCERS = getDefaultMetaReducers(ACTIONS);

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    if (has(REDUCERS, action.type))
    {
        return REDUCERS[action.type](state, action.payload);
    }

    return state;
}
